import React from 'react';
import ReactDOM from "react-dom/client";
import {getThemeStyles, IBaseColorsConfig} from "../app/styles/themeStyles";
import {GlobalStyle} from "../app/styles/GlobalStyles";
import {ThemeProvider} from "styled-components";
import {WidgetSettingsT, WidgetSettingsContext} from '../shared/context/WidgetSettingsContext';

/**
 * Универсальная функция для отрисовки React-компонента (виджета) в указанном DOM-контейнере.
 *
 * Используется для интеграции разных виджетов в конкретные участки DOM, например, как самостоятельные модули,
 * вставляемые на страницу или в модальное окно.
 *
 * @param container - HTML-элемент, в который будет отрисован React-компонент.
 * @param Component - React-компонент (например, SearchPageRoot, IFurnSearchPageRoot и т.д.), который нужно отрисовать.
 * @param themeConfig - конфигурация темы (цвета и стили), применяется через styled-components ThemeProvider.
 * @param settings - объект с настройками виджета (фильтры, исключения, API-канал), прокидывается через контекст.
 *
 * Обёртки:
 * - `<ThemeProvider>` — применяет глобальные стили темы.
 * - `<GlobalStyle />` — глобальные CSS-стили, определённые через styled-components.
 * - `<WidgetSettingsContext.Provider>` — передаёт настройки виджета в дочерние компоненты.
 *
 * ⚠️ Важно:
 * - Эта функция предполагает, что контейнер уже существует в DOM.
 * - Компонент должен быть функцией (`React.FC`) и корректно обрабатывать контекст.
 */
export const renderWidget = (
    container: HTMLElement,
    Component: React.FC,
    themeConfig: IBaseColorsConfig,
    settings: WidgetSettingsT
) => {
    const root = ReactDOM.createRoot(container);
    root.render(
        <ThemeProvider theme={getThemeStyles(themeConfig)}>
            <GlobalStyle/>
            <WidgetSettingsContext.Provider value={settings}>
                <Component/>
            </WidgetSettingsContext.Provider>
        </ThemeProvider>
    );
};

